module.exports = __webpack_public_path__ + "img/4.744c18e4.png";